<ng-container *ngFor="let errorMessage of errorMessages">
    <small *ngIf="errorMessage !== undefined"  class="caption status-danger ng-star-inserted text-danger message">
        {{ errorMessage }}
    </small><br/>
</ng-container>